// extracted by mini-css-extract-plugin
export default {"commentsWrapper":"comments_commentsWrapper__96eee","circle":"comments_circle__N3w7V","text":"comments_text__SDkB-"};